import { RncpDto, RncpFilterField, RncpProjection } from '@common/services/rncp';
import { buildPageableParams, Page, PageableArgs } from '../common';
import { queryDownloadFile } from '../common/pageable/query-download-file';
import { servicesApi } from '../services';

const CAMPAGNES_RNCPS_URL_PREFIX = (id: number) => `campagnes/${id}/rncps`;

const campagneRncpApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getSelectedCampagneRncpsFromExcel: build.mutation<RncpDto[], GetSelectedCampagneRncpsFromExcelMutationArgs, any>({
      query: ({ id, body }) => ({
        method: 'POST',
        url: `${CAMPAGNES_RNCPS_URL_PREFIX(id)}/excel`,
        body,
      }),
    }),

    downloadSelectedCampagneRncpsExcel: build.mutation<void, DownloadSelectedCampagneRncpsQueryArgs, any>({
      queryFn: ({ id, rncpIds }, api, extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${CAMPAGNES_RNCPS_URL_PREFIX(id)}/excel`,
        params: { rncpIds },
        defaultFilename: 'Certifications',
      }),
    }),

    getCampagneRncps: build.query<Page<RncpDto>, GetCampagneRncpsQueryArgs, any>({
      query: ({ id, ...pageable }) => ({
        url: CAMPAGNES_RNCPS_URL_PREFIX(id),
        params: buildPageableParams(pageable),
      }),
      providesTags: ['CampagneRncps'],
    }),

    downloadCampagneRncps: build.mutation<void, DownloadCampagneRncpsMutationArgs, any>({
      queryFn: ({ id }, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${CAMPAGNES_RNCPS_URL_PREFIX(id)}/export`,
      }),
    }),

    importCampagneRncps: build.mutation<void, ImportCampagneRncpsMutationArgs, any>({
      query: ({ id, body }) => ({
        method: 'POST',
        url: `${CAMPAGNES_RNCPS_URL_PREFIX(id)}/import`,
        body,
        meta: { skipErrorToast: true },
      }),
      invalidatesTags: ['CampagneRncps'],
    }),

    getCampagneRncpsDistinctField: build.query<Page<RncpDto>, GetCampagneRncpsDistinctQueryArgs, any>({
      query: ({ id, field }) => ({
        url: `${CAMPAGNES_RNCPS_URL_PREFIX(id)}/distinct`,
        params: { field },
      }),
      providesTags: ['CampagneRncps'],
    }),
  }),
});

interface GetSelectedCampagneRncpsFromExcelMutationArgs {
  id: number;
  body: FormData; // excel: File
}

interface DownloadSelectedCampagneRncpsQueryArgs {
  id: number;
  rncpIds: number[];
}

interface GetCampagneRncpsQueryArgs extends PageableArgs<RncpProjection> {
  id: number;
}

interface DownloadCampagneRncpsMutationArgs extends PageableArgs<RncpProjection> {
  id: number;
}

interface ImportCampagneRncpsMutationArgs {
  id: number;
  body: FormData; // excel: File
}

interface GetCampagneRncpsDistinctQueryArgs {
  id: number;
  field: RncpFilterField;
}

export const {
  useGetCampagneRncpsQuery,
  useGetSelectedCampagneRncpsFromExcelMutation,
  useDownloadSelectedCampagneRncpsExcelMutation,
  useDownloadCampagneRncpsMutation,
  useImportCampagneRncpsMutation,
  useGetCampagneRncpsDistinctFieldQuery,
} = campagneRncpApi;
